<!-- footer -->
<template>
  <!-- <div class="v-footer">
      <div class="center">
        <el-row :gutter="10">
          <el-col class="left" :xs="16" :sm="16" :md="18" :lg="20" :xl="20">
            <div class="">
              <span @click="linkUrl(item.id)" 
                    :style="item.id!==''?'cursor:pointer;':''"
                    v-for="(item,index) in footerList" 
                    :key="index">{{item.name}}</span>
            </div>
            <div class="bottom">
              软通动力教育科技有限公司 版权所有 京ICP备11000018号-15 京公网安备110000000826号 
            <br/>地址：北京市海淀区西北旺东路10号院东区16号楼
            </div>
          </el-col>
          <el-col class="right" :xs="8" :sm="8" :md="6" :lg="4" :xl="4">
            <img class="navLogo"  :src="require('@/assets/images/erweima.jpg')" alt />
            <div class="point">关注我们</div>
          </el-col>
        </el-row>
      </div>
  </div> -->
  <div class='footer v-footer'>
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-links-list">
            <div class="link"><a href="/newbuild/?id=P20092217533003">公司简介</a></div>
            <div class="link"><a href="/newbuild/?id=P20092217421303">校园招聘</a></div>
            <div class="link"><a href="/build/?id=P20092217551803">联系我们</a></div>
          </div>
          <div class="address">
            <div>北京软通动力教育科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备17037728号-6</a></div>
            <div>地址：北京市海淀区西北旺东路10号院东区16号楼</div>
          </div>
        </div>
        <div class="footer-section">
              <div class="friend-txt">友情链接</div>
              <div class="logo-list">
                <a class="logo" href="http://www.isoftstone.com">
                <img :src="require('@/assets/images/footerlogo02.png')"/>
                </a>
                <a class="logo" href="https://www.issedu365.com">
                <img :src="require('@/assets/images/footerlogo01.png')"/>
                </a>
              </div>
        </div>
        <div class="footer-section wx-code-section">
          <div class="wx-code">
              <img :src="require('@/assets/images/erweima.jpg')"/>
          </div>
          <div class="wx-txt">关注我们</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-footer",
  data() {
    return {
      footerData:[],
      footerList:[{name:"公司简介",id:"P20092217533003"},
                  {name:"校园招聘",id:"P20092217421303"},
                  {name:"联系我们",id:"P20092217551803"}],
      
    };
  },
  created() {
    // console.log("menuVal",this.menuVal);
  },
  methods: {
    linkUrl(_id){
      var that = this;
        that.$router.push({'name':'build',query:{"id":_id}});
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      console.log(key, keyPath);
    },
    numberToString(_data){
      return (_data+1).toString();
    }
  },
};
</script>

<style lang="scss">

</style>
